import React from "react";
import "./about.css";
import { Fade } from "react-awesome-reveal";
const Aboutus = ({ title, desc, link, Arabic }) => {
  return (
    <div id="about">
      <section className="about">
        <h3 className="tit text-center">من نحن</h3>
        <div className="container">
          <div className="row">
            <div className="col-md-6 ">
              <Fade direction="left" triggerOnce="false">
                <h2 className="text-uppercase">VIP COMMUNITY SERVICES</h2>
                <p>
                  نحن شركة vip متخصصين في تقديم كافة الخدمات من استيراد السيارات
                  وخدمات السياحة من حجز تذاكر الطيران والأقامة وغيراها وكافة
                  خدمات الشهر العقاري من اعمال توكيلات واعمال تحرير وتوثيق
                  وخدمات المحليات وايضاً جميع خدمات المرور من استخراج رخصة
                  وتجديد وبدل فاقد للأفراد وللمركبات وتخليص المعاملات بأنواعها
                </p>
              </Fade>
            </div>
            <div className="col-md-6">
              <Fade direction="right" triggerOnce="false">
                <img
                  src={"logo.png"}
                  className="img-responsive"
                  alt="feature img"
                />
              </Fade>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Aboutus;
